module.exports = __webpack_public_path__ + "static/img/xinlinian.b8b229a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mImg/xinlinian.jpg
// module id = lK0Y
// module chunks = 0